<template>
<ol v-if="categorySelected" class="breadcrumb">

	<li class="breadcrumb-item">
		<a href="#" v-on:click.prevent="$emit('deselectCategory')">
			Categories
		</a>
	</li>

	<li v-if="!templateSelected" class="breadcrumb-item">
		{{categorySelected.name}}
	</li>
	<template v-else>
		<li class="breadcrumb-item">
			<a href="#" v-on:click.prevent="$emit('deselectTemplate')">
			{{categorySelected.name}}
			</a>
		</li>
	
		<li class="breadcrumb-item">
			{{templateSelected.title}}
		</li>

	</template>
</ol>
</template>
<script type="text/javascript">
export default {
	name: "FormSelectorBreadcrumb",
	props: [
		"categorySelected",
		"templateSelected"
	]
}	
</script>